<template>
  <div class="container box-center">
    <div class="common-header-wrap">
      <mt-header class="common-header" :title="$t('payment')">
        <mt-button v-if="isback" icon="back" slot="left" @click="goBack"></mt-button>
      </mt-header>
    </div>

    <div v-if="pay_info">
      <!-- <div class="top-wrapper">
        <div class="row-wrapper title-wrapper">
          <i class="iconfont">&#xe6d2;</i>
          <label class="title">{{ $t('Order submitted successfully, please select payment method') }}</label>
        </div>
        <div class="subtitle-wrapper">
          <label class="subtitle">{{ $t('cart.total') }}: </label>
          <label class="price">${{ pay_info.pay_amount }}</label>
        </div>
      </div> -->


      <div class="recharge-type-tabs" v-if="bank_status == '1'">
        <div :class="['tab-item', currentCurrency == 1 ? 'active' : '']" @click="switchCurrency(1)" >
          USDT
        </div>
        <div :class="['tab-item', currentCurrency == 2 ? 'active' : '']" @click="switchCurrency(2)" >
          {{ $t("account.bank") }}
        </div>
      </div>

      <div class="main-content" v-show="currentCurrency == 1">
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">
            {{ $t('Account Type') }}
          </span>
          <!-- <div>
            <span>{{ $t('USDT') }}</span>
            <span class="left-price" style="margin-left: .5rem;">${{ pay_info.member_available_pd }}</span>
          </div> -->
          <div class="field-line-right" slot="right">
            <div class=" custom-select-wrapper">
            <select
              v-model="selectedAddress"
              class="custom-select"
            >
              <option value="BEP20">USDT-BNB Smart Chain (BEP20)</option>
              <option value="opBNB">USDT Address (opBNB)</option>
            </select>
            </div>
          </div>
          <!-- <div slot="right">
            <mt-switch v-model="payment_info.pd_pay"></mt-switch>
          </div> -->
        </flex-line>
        <flex-line v-if="pay_info.member_available_rcb > 0" :show-border="true">
          <div>
            <span>{{ $t('Rechargeable card') }}</span>
            <span class="left-price">${{ pay_info.member_available_rcb }}</span>
          </div>
          <div slot="right">
            <mt-switch v-model="payment_info.rcb_pay"></mt-switch>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">
            {{ $t('cart.total') }}
          </span>
          <div class="field-line-right" slot="right">
            <input class="field-input" type="text" v-model="pay_info.pay_amount" readonly />
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true" v-if="pay_type != 'pay_new'">
          <span class="field-name">
            {{ $t('Collection address') }}
          </span>
          <div class="field-line-right" slot="right">
            <input class="field-input" style="font-size: .6rem;" type="text" v-model="address_info" readonly />
            <div class="copy" @click.stop="copySuccess(address_info)"> {{ $t('Copy') }}</div>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true" v-if="pay_type != 'pay_new'">
          <span class="field-name">
            {{ $t('Please enter a hash') }}
          </span>
          <div class="field-line-right" slot="right">
            <!-- <input class="field-input" type="text" :placeholder="$t('Please enter')" v-model="hash" /> -->
            <textarea ref="autoResizeTextarea" @input="autoResize" rows="1" cols="50" wrap="soft"
              :placeholder="$t('Please enter')" v-model="hash"></textarea>
          </div>
        </flex-line>

        <div class="updata" v-if="pay_type != 'pay_new'">
          <div class="tit">{{ $t('Upload credentials') }}</div>
          <div class="upload-container" @change="uploadImage($event)">
            <label for="fileInput" class="upload-button" v-if="!imgSrc1">
              <span class="plus-icon">+</span>
            </label>
            <div class="img" v-else>
              <img :src="imgSrc1" style="width: 10rem;" alt="">
              <div class="x" @click="imgSrc1 = ''; imgSrc = '';">X</div>
            </div>
            <input type="file" :value="inputValue" id="fileInput" accept="image/*" style="display: none;">
          </div>
        </div>
      </div>
      <div class="main-content" v-show="currentCurrency == 2">
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("account.name") }}</span>                             
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" v-model="yhkInfos.bank_account" readonly/>
            <div class="copy-bk" @click.stop="copySuccess(yhkInfos.bank_account)">{{ $t("Copy") }}</div>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("bank.name") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" v-model="yhkInfos.bank_name" readonly/>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("account.number") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" v-model="yhkInfos.account" readonly/>
            <div class="copy-bk" @click.stop="copySuccess(yhkInfos.account)">{{ $t("Copy") }}</div>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("account.ifsc") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" v-model="yhkInfos.ifsc" readonly/>
            <div class="copy-bk" @click.stop="copySuccess(yhkInfos.ifsc)">{{ $t("Copy") }}</div>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("Account Type") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" value="Saving" readonly/>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <span class="field-name">{{ $t("bank.upi.code") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input usdt_address" v-model="yhkInfos.upi" readonly/>
            <div class="copy-bk" @click.stop="copySuccess(yhkInfos.upi)">{{ $t("Copy") }}</div>
          </div>
        </flex-line>
        <flex-line class="input-wrapper" :show-border="true">
          <div style="display: flex;align-items: center;">
            <span class="field-name">USDT</span>
          </div>
          <div class="field-line-right" slot="right">
            <input
              class="field-input"
              type="text"
              v-model="pay_info.pay_amount" readonly/>
            <b class="inr-amount">={{ inrAmount }}INR</b>
            <span class="copy">
              <span style="color:#868686;">{{ inrRate }}</span>&nbsp;&nbsp;
              <span @click.stop="copySuccess(inrAmount)">{{ $t("Copy") }}</span>
            </span>
          </div>
        </flex-line>
        <div v-if="yhkInfos.upi_code_img_status == '1'">
          <div class="code-i-txt">{{ $t('bank.upi') }}</div>
          <img :src="yhkInfos.upi_code_img" class="qrImg">
          <div class="code-i-txt">{{ $t('bank.img.save') }}</div>
        </div>
        <div style="line-height: 16px;font-size: 14px;text-align: center;">{{ $t('bank.pay.tip') }}</div>
        <flex-line class="input-wrapper" :show-border="true" v-if="pay_type != 'pay_new'">
          <span class="field-name">{{ $t('bank.upi.order') }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input" :placeholder="$t('Please enter')" v-model="hash1"/>
          </div>
        </flex-line>
        <div class="updata" v-if="pay_type != 'pay_new'">
          <div class="tit">{{ $t("Upload credentials") }}</div>
          <div class="upload-container" @change="uploadImage2($event)">
            <label for="fileInput2" class="upload-button" v-if="!imgSrc2">
              <span class="plus-icon">+</span>
            </label>
            <div class="img" v-else>
              <img :src="imgSrc2" style="width: 10rem" alt="" />
              <div
                class="x"
                @click="
                  imgSrc2 = '';
                  imgSrc3 = '';
                "
              >X</div>
            </div>
            <input
              type="file"
              :value="inputValue2"
              id="fileInput2"
              accept="image/*"
              style="display: none"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="common-add-btn-wrapper">
      <div class="common-btn ds-button-large" @click="submit">{{ $t('Immediate payment') }}</div>
    </div>

    <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('CropImage')" class="common-header">
          <mt-button slot="left" icon="back" @click="showCrop = false"></mt-button>
          <div class="common-btn btn" slot="right" @click="useCrop">{{ $t('UseImage') }}</div>
        </mt-header>
      </div>
      <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper"
        :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth"
        :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img"
        :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
    </mt-popup>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { getStoreJoinin } from '../../../api/seller'
import { getAddressInfo, getOrderpayInfo,getHYHhkAddressInfo } from '../../../api/memberBuy'
import { getVrOrderpayInfo } from '../../../api/memberVrBuy'
import { mapState } from 'vuex'
import { pay, pay_new, getPaymentList } from '../../../api/memberPayment'
import { getRechargeInfo,getRechargeList } from '../../../api/memberRecharge'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { loadScript } from '../../../util/common'
import { isWechat } from '../../../util/wechat'
import flexLine from '../../flexLine'
import { upload_file } from '../../../api/member'
export default {
  name: 'pay',
  data() {
    return {
      selectedAddress: "BEP20",
      uniapp: 0,
      pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
      pay_type: this.$route.query.pay_type ? this.$route.query.pay_type : '',
      // 订单支付显示的数据
      pay_info: null,
      isback: false,
      // 提交支付需要用到的数据
      payment_info: {
        password: '', // 支付密码
        rcb_pay: 0, // 是否使用充值卡进行支付
        pd_pay: 1, // 是否使用预存款进行支付 USDT
        payment_code: 'usdt_h5' // 支付方式

      },
      payment_list: [],
      showNotice: 0,
      notice: this.$route.query.notice,
      ifLoaded: 0,
      hash: '', // 哈希
      hash1: '',
      inrRate: '', // 汇率
      inrAmount: 0, // INR金额
      bank_status: '0', // 银行卡充值是否开启
      showCrop: false,
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      imgSrc: "",
      imgSrc1: "",
      imgSrc2: "",
      imgSrc3: "",
      inputValue: "",
      inputValue2: "",
      file: null,
      address_info: null,
      showPassword: false,
      currentCurrency: 1,
      yhkInfos:{},//银行卡充值相关数据
    }
  },
  components: {
    flexLine,
    VueCropper
  },
  computed: {
    ...mapState({
      token: state => state.member.token

    })
  },
  created: function () {
    let _this = this
    _this.ifLoaded = 2

    this.getMemberPayInfo()
    getAddressInfo().then(res => {
      if (res.code == 10000) {
        this.address_info = res.result
      }
    })
    getHYHhkAddressInfo().then((res) => {
      console.log('银行卡信息67',res)
      if (res.code == 10000) {
        this.yhkInfos = res.result;
      }
    });
    this.payment_info.pd_pay = this.$route.query.pay_type == 'pay_new' ? '1' : 0
  },
  watch: {
    showNotice: function (val) {
      if (val && this.notice) {
        MessageBox.confirm('如果您已完成支付，请点击“完成付款”按钮，如果您未完成支付，请点击“重新支付”重新发起支付', '确认支付是否完成', { cancelButtonText: '重新支付', confirmButtonText: '完成付款' }).then(action => {
          this.goNext()
        })
      }
    },
    ifLoaded: function (val) {
      if (val >= 2) {
        this.getPaymentList()
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name != 'MemberBuyStep1') {
        vm.isback = true
      }
    })
  },
  methods: {
     //切换选择
    switchCurrency(type) {
      if (this.currentCurrency === type) return;
      this.currentCurrency = type;
      
    },
    autoResize() {
      const textarea = this.$refs.autoResizeTextarea;
      // Reset the height to the minimum, then set it to the scrollHeight
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t('succ'))
          // console.log(e);
        }, (e) => {
          Toast(this.$t('err'))
          // console.log(e);
        }
      );
    },
    uploadImage(e) {
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      this.file = e.target.files[0];
      Indicator.open(); // 打开加载指示器
      // 压缩图片并上传
      this.compressImage(file, 0.5, 400).then(compressedFile => {
        const formData = new FormData();
        formData.append('file', compressedFile);
        this.imgSrc1 = URL.createObjectURL(compressedFile);
        // 上传图片
        upload_file(formData)
          .then(res => {
            if (res.code == 10000) {
              this.imgSrc = res.result;
            } else {
              Toast(res.message);
              this.imgSrc = "";
              this.imgSrc1 = "";
            }
            this.showCrop = false;
            Indicator.close(); // 关闭加载指示器
          })
          .catch(() => {
            Indicator.close(); // 关闭加载指示器
            console.error("图片上传失败");
          });
      }).catch(error => {
        Indicator.close(); // 关闭加载指示器
        console.error("图片压缩失败", error);
      });
    },
     uploadImage2(e) {
      const file = e.target.files[0];
      if (!file) {
        return;
      }
      this.file = e.target.files[0];
      Indicator.open(); // 打开加载指示器
      // 压缩图片并上传
      this.compressImage(file, 0.5, 400).then(compressedFile => {
        const formData = new FormData();
        formData.append('file', compressedFile);
        this.imgSrc2 = URL.createObjectURL(compressedFile);
        // 上传图片
        upload_file(formData)
          .then(res => {
            if (res.code == 10000) {
              this.imgSrc3 = res.result;
            } else {
              Toast(res.message);
              this.imgSrc2 = "";
              this.imgSrc3 = "";
            }
            this.showCrop = false;
            Indicator.close(); // 关闭加载指示器
          })
          .catch(() => {
            Indicator.close(); // 关闭加载指示器
            console.error("图片上传失败");
          });
      }).catch(error => {
        Indicator.close(); // 关闭加载指示器
        console.error("图片压缩失败", error);
      });
    },

    /**
     * 压缩图片
     * @param {File} file - 原始图片文件
     * @param {number} quality - 压缩质量 (0 到 1 之间)
     * @param {number} maxWidth - 最大宽度（单位：像素）
     * @returns {Promise<File>} 返回压缩后的图片文件
     */
    compressImage(file, quality, maxWidth) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            // 计算等比缩放后的宽高
            let width = img.width;
            let height = img.height;
            if (width > maxWidth) {
              const ratio = maxWidth / width; // 等比缩放比例
              width = maxWidth;
              height = height * ratio; // 高度按比例调整
            }
            // 设置 Canvas 的尺寸为缩放后的宽高
            canvas.width = width;
            canvas.height = height;
            // 绘制图片到 Canvas
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            // 将 Canvas 转换为 Blob，并设置压缩质量
            canvas.toBlob(
              blob => {
                if (blob) {
                  // 创建新的 File 对象
                  const compressedFile = new File([blob], file.name, {
                    type: file.type,
                    lastModified: Date.now()
                  });
                  resolve(compressedFile);
                } else {
                  reject(new Error("Unable to generate compressed image"));
                }
              },
              file.type, // 图片类型
              quality // 压缩质量
            );
          };
          img.onerror = error => {
            reject(error);
          };
        };
        reader.onerror = error => {
          reject(error);
        };
        // 读取文件内容
        reader.readAsDataURL(file);
      });
    },
    useCrop() {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        Indicator.open()
        upload_file(formdata).then(res => {
          if (res.code == 10000) {
            this.imgSrc = res.result
          }
          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    goBack() {
      if (this.notice) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    setClass(code) {
      let obj = {}
      obj['icon ' + code] = true
      return obj
    },
    goNext() {
      if (this.pay_type === 'pay_new') {
        this.$router.replace({ name: 'MemberOrderList' })
      } else if (this.pay_type === 'vr_pay_new') {
        this.$router.push({ name: 'MemberVrOrderList' })
      } else if (this.pay_type === 'sj_pay') {
        this.$router.push({ name: 'HomeSellerLogin' })
      } else if (this.pay_type === 'pd_pay') {
        this.$router.push({ name: 'MemberAccount' })
      }
    },
    payType(code) {
      this.payment_info.payment_code = code
    },
    getPaymentList() {
      let _this = this
      var from = ''
      var code = ''
      if (isWechat()) {
        code = 'wxpay_jsapi'
      }
      // uni.getEnv(function (res) {
      //   if (res.plus) {
      //     from = 'app'
      //   }
      // })
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          code = 'wxpay_minipro'
        }
      })
      getPaymentList(from, code).then(res => {
        this.payment_list = res.result.payment_list
        if (this.payment_list.length) {
          this.payment_info.payment_code = this.payment_list[0].payment_code
        }

      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getMemberPayInfo() {
      if (this.pay_type === 'pay_new') {
        let _this = this
        getOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'vr_pay_new') {
        let _this = this
        getVrOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'sj_pay') {
        let _this = this
        getStoreJoinin().then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.store_joinin
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'pd_pay') {
        getRechargeInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = { pay_amount: res.result.pdinfo.pdr_amount }
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      }
      setTimeout( ()=> {
        getRechargeList({page:1}).then((res) => {
          let val = (Number(res.result.inr_usd_rate) * Number(this.pay_info.pay_amount)).toFixed(2)
          this.inrRate = '1USDT = ' + res.result.inr_usd_rate + 'INR'
          this.inrAmount = val
          this.bank_status = res.result.bank_status
        });
      },1000)
    },
    submit() {
      if (this.ifLoaded < 2) {
        Toast(this.$t('Wait for the file to load'))
        return
      }

      if (this.payment_info.pd_pay || this.payment_info.rcb_pay) {
        if (!this.payment_info.password) {
          let that = this
          MessageBox({
            $type: 'prompt',
            title: that.$t('MessageBox.Tips'),
            message: that.$t('Please enter') + ' ' + that.$t('Payment Password'),
            confirmButtonText: that.$t('MessageBox.Confirm'),
            cancelButtonText: that.$t('MessageBox.Cancel'),
            showCancelButton: true,
            showInput: true,
          }).then(({ value, action }) => {
            if (action == 'confirm') {
              this.payment_info.password = value
              this.submit()
            }
          }).catch(() => { })
          return

        }
      }

      var param = 'action=' + this.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code
      if (this.payment_info.payment_code == 'wxpay_minipro') {
        wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
        return
      }
      if (this.uniapp) {
        uni.redirectTo({ url: 'pay?' + param })
        return
      }
      if (this.pay_type != "pay_new") {
        if(this.currentCurrency == 1){
          if (!this.hash) {
            Toast(this.$t("Please enter a hash"));
            return;
          }
          if (!this.imgSrc) {
            Toast(this.$t("Upload credentials"));
            return;
          }
          this.inrAmount = 0
        }else{
          if (!this.imgSrc3) {
            Toast(this.$t("Upload credentials"));
            return;
          }
          if (!this.hash1) {
            Toast(this.$t("Please enter a upi order"));
            return;
          }
          this.payment_info.payment_code = 'inr'
          this.hash = this.hash1
          this.imgSrc = this.imgSrc3
        }
      }
      if (this.pay_type === 'pay_new') {
        pay_new(
          this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp, this.hash, this.imgSrc
        ).then((res) => {
          if (res.code) {
            if (res.code === 10000 || res.code === 12001) {
              this.goNext()
              Toast(res.message)
            } else {
              Toast(res.message)
            }
          } else {
            document.write(res)
          }
        }).catch(function (error) {
          if (error.message) {
            Toast(error.message)
          } else {
            document.write(error)
          }
        })

      } else {
        pay(
          this.pay_sn,
          this.pay_type,
          this.payment_info,
          this.token,
          this.uniapp,
          this.hash,
          this.imgSrc,
          this.inrAmount
        ).then((res) => {
          if (res.code) {
            if (res.code === 10000 || res.code === 12001) {
              this.goNext()
              Toast(res.message)
            } else {
              Toast(res.message)
            }
          } else {
            document.write(res)
          }
        }).catch(function (error) {
          if (error.message) {
            Toast(error.message)
          } else {
            document.write(error)
          }
        })
      }


    }
  }
}
</script>

<style scoped lang='scss'>
.code-i-txt {
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  font-size: 14px;
}
.qrImg {
  width: 10rem;display: block;margin: 10px auto;
}
.recharge-type-tabs {
  display: flex;
  justify-content: space-around;
  margin: 12px;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;

  .tab-item {
    flex: 1;
    padding: 10px 0;
    text-align: center;
    background-color: #f5f5f5;
    color: #666;
    cursor: pointer;

    &.active {
      background-color: #fff;
      color: #ee0a24;
      font-weight: bold;
      border-bottom: 2px solid #ee0a24;
    }
  }
}
.common-add-btn-wrapper {
  width: 100%;
  position: relative;
  bottom: 0;
  left: 0;

  .ds-button-large {
    max-width:200px;
    margin: 0 auto;
    background: #E7010C;
  }
}

.box-center {
  
  padding-bottom: 2.5rem;
  box-sizing: border-box;
  background: #fff;
  background-color: #fff !important;
}

.common-header {
  box-shadow: none;
}

.updata {
  padding: 1px;

  .tit {
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
}

.upload-container {
  text-align: left;
  margin: 10px;
}

.upload-button {
  display: inline-block;
  width: 100px;
  height: 100px;
  background-color: #ebebeb;
  color: white;
  border-radius: 0%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
  overflow: hidden;
}

.img {
  max-width: 10rem;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: block;
    border: 1px solid #ddd;
  }

  .x {
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    font-size: 12px;
    border-radius: 50%;
    background: #c7c7c7;
    position: absolute;
    top: 0;
    right: -1rem;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}

.upload-button:hover {
  background-color: #0056b3;
}

.plus-icon {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
}

/* 隐藏实际的文件输入框 */
#fileInput {
  display: none;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: $mainbgColor;
  position: relative;
}

.bottom-wrapper {
  background: #fff;
  position: absolute;
  width: 100%;
  padding: .5rem $pageSpace;
  box-sizing: border-box;
  bottom: 0;
  left: 0;
}

.main-content {
  padding: 0 1rem;
  background: #fff
}

.top-wrapper {
  padding: 0 $pageSpace;
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  margin-bottom: 0.75rem;
}

.row-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.title-wrapper {
  height: 3.2rem;

  i {
    font-size: $mainFontSize;
    margin-right: .2rem;
  }
}

.subtitle-wrapper {
  height: 1.5rem;
  text-align: right;
}

.icon {
  width: 1.2rem;
  height: 1.2rem;
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.title {
  font-size: $subFontSize;
  color: $formInputColor;
  font-weight: 700;
}

.subtitle {
  font-size: $subFontSize;
  color: $descTextColor;
}

.price {
  font-size: $h2;
  color: $primaryColor;
  font-weight: 700;
}

.left-price {
  font-size: $h2;
  color: #48A1FB;
}

.item-wrapper {
  height: 3.1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid $lineColor;
}

.item-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
}

.item-left-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  i {
    background-image: url(../../../assets/image/wxpayicon.png);
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .alipay_h5,
  .alipay_app {
    background-image: url(../../../assets/image/alipayicon.png);
  }

  .unionpay_h5 {
    background-image: url(../../../assets/image/unionpayicon.png);
  }
}

.item-right-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.item-subtitle {
  font-size: $h2;
  color: #8C8C8C;
  margin-right: 0.25rem;
  text-align: right;
}

.item-select {
  font-size: 1.2rem;
  color: #7ED321;
}

.indicator {
  width: 0.7rem;
  height: 0.7rem;
  margin-left: 0.25rem;
  margin-right: 0.8rem;
}

.action-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  margin-top: 2.25rem;
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  align-items: center;
  background-color: #fff;

  flex-direction: column;
  align-items: flex-start;
  margin: .4rem 0;

  .field-name {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin: .5rem 0;
  }

  input,
  textarea {
    display: block;
    font-size: $subFontSize;
    flex: 1;
    width: 100%;
    text-align: left !important;
    padding: .9rem;
    border-radius: .4rem;
    background: #FAFAFA;
    border-radius: 5px 5px 5px 5px;
    box-sizing: border-box;
    border: none;
  }

  .bottom-input {
    border-bottom-width: 0;
  }

  .field-line-right {
    width: 100%;
    position: relative;

    .copy,.copy-bk {
      cursor: pointer;
      position: absolute;
      top: -30%;
      right: 0.5rem;
      transform: translate(0, -50%);
      font-size: 0.56rem;
      font-weight: 600;
      color: #ff0000;
    }
    .copy-bk{top:50%;}
    .inr-amount{
      position: absolute;
      top: 50%;
      right: 0.5rem;
      transform: translate(0, -50%);
      font-size: 1rem;
      font-weight: 600;
      color: #000000;
    }
  }

  ::v-deep(.right) {
    width: 100%;
  }
}
.custom-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.custom-select {
  width: 100%;
  padding: 10px 14px;
  font-size: 15px;
  font-weight: 600;
  color: #e7010c;
  border: 1px solid rgba(212, 207, 205, 1);
  border-radius: 12px;
  background-color: #fff;
  appearance: none; /* 去掉系统默认样式 */
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='14' height='9' viewBox='0 0 14 9' xmlns='http://www.w3.org/2000/svg'><path fill='gray' d='M1 1l6 6 6-6'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
}

.custom-select:focus {
  outline: none;
  border-color: #e7010c;
  box-shadow: 0 0 4px rgba(231, 1, 12, 0.3);
}

.custom-select option {
  color: #333;
  font-weight: 500;
}
</style>
